var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 67,
    viewBox: "0 0 64 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 64,
    height: 65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03234 13.2126L26.7859 3.21413C29.9091 1.63333 33.5981 1.63333 36.7212 3.21413L56.4748 13.2126C60.1749 15.0854 62.5072 18.88 62.5072 23.027V43.9963C62.5072 48.0763 60.2489 51.8211 56.6404 53.7251L36.7819 64.2031C33.6279 65.8672 29.8628 65.8992 26.681 64.2887L7.03235 54.3433C3.3323 52.4705 1 48.6759 1 44.5289L1 23.027C1 18.88 3.3323 15.0854 7.03234 13.2126Z",
    fill: "#C4C4C4",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.1172,
    y: -10.1865,
    width: 95.5855,
    height: 87.5108,
    fill: "#008ED6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -36.8188,
    cy: -4.74333,
    rx: 59.4292,
    ry: 59.8758,
    fill: "#0067AA",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.4816,
    cy: 30.6378,
    rx: 48.4161,
    ry: 48.7799,
    fill: "#0168A9",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.1691,
    cy: 72.9279,
    rx: 48.4161,
    ry: 48.7799,
    fill: "#00568D",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7522 25.4002L36.4713 35.997H28.057L26.3041 40.9613H38.2006L40.5221 47.5723C40.7116 48.0337 40.9959 48.4156 41.3749 48.7179C41.7697 49.0043 42.275 49.1475 42.8909 49.1475H48.4104L35.0026 14.5171H27.7303L14.2988 49.1475H19.8656C20.4658 49.1475 20.9632 48.9884 21.358 48.6702C21.7528 48.336 22.0292 47.9701 22.1871 47.5723L24.5086 40.9613L26.2616 35.997L29.957 25.448C30.1781 24.8911 30.4071 24.2387 30.6439 23.4909C30.8966 22.7272 31.1335 21.8998 31.3546 21.0088C31.5757 21.8839 31.8047 22.6954 32.0416 23.4432C32.2943 24.191 32.5311 24.8434 32.7522 25.4002Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2926a8a9.svg";
export { ForwardRef as ReactComponent };